// API Configuration for Bhajan Management
const API_CONFIG = {
  // Production Render URL
  PRODUCTION: 'https://pooja-path-1.onrender.com',

  // Local development URL
  DEVELOPMENT: 'http://localhost:8000',

  // Current environment - change this to switch between local and production
  CURRENT_ENV: 'PRODUCTION', // Change to 'DEVELOPMENT' for local testing

  // Get the current base URL
  getBaseUrl: () => {
    return API_CONFIG[API_CONFIG.CURRENT_ENV];
  },

  // Get the bhajan categories endpoint
  getBhajanCategoriesUrl: () => {
    return `${API_CONFIG.getBaseUrl()}/api/bhajan_sangrah/categories/`;
  },

  // Get category detail URL
  getCategoryDetailUrl: (categoryId) => {
    return `${API_CONFIG.getBaseUrl()}/api/bhajan_sangrah/categories/${categoryId}/`;
  },

  // Add category URL
  getAddCategoryUrl: () => {
    return `${API_CONFIG.getBaseUrl()}/api/bhajan_sangrah/categories/add/`;
  },

  // Delete category URL
  getDeleteCategoryUrl: (categoryId) => {
    return `${API_CONFIG.getBaseUrl()}/api/bhajan_sangrah/categories/${categoryId}/delete/`;
  },

  // Add bhajan URL
  getAddBhajanUrl: (categoryId) => {
    return `${API_CONFIG.getBaseUrl()}/api/bhajan_sangrah/categories/${categoryId}/bhajans/add/`;
  },

  // Delete bhajan URL
  getDeleteBhajanUrl: (categoryId, bhajanTitle) => {
    return `${API_CONFIG.getBaseUrl()}/api/bhajan_sangrah/categories/${categoryId}/bhajans/${encodeURIComponent(bhajanTitle)}/delete/`;
  },

  // PATHH ENDPOINTS
  getPathhCategoriesUrl: () => {
    return `${API_CONFIG.getBaseUrl()}/api/pathh/categories/`;
  },
  getPathhCategoryDetailUrl: (categoryId) => {
    return `${API_CONFIG.getBaseUrl()}/api/pathh/categories/${categoryId}/`;
  },
  getAddPathhCategoryUrl: () => {
    return `${API_CONFIG.getBaseUrl()}/api/pathh/categories/add/`;
  },
  getDeletePathhCategoryUrl: (categoryId) => {
    return `${API_CONFIG.getBaseUrl()}/api/pathh/categories/${categoryId}/delete/`;
  },
  getAddPathhUrl: (categoryId) => {
    return `${API_CONFIG.getBaseUrl()}/api/pathh/categories/${categoryId}/pathhs/add/`;
  },
  getDeletePathhUrl: (categoryId, pathhTitle) => {
    return `${API_CONFIG.getBaseUrl()}/api/pathh/categories/${categoryId}/pathhs/${encodeURIComponent(pathhTitle)}/delete/`;
  }
};

export default API_CONFIG;